import { Location, NavigateFunction } from "react-router";

export const history = {
  navigate: null as NavigateFunction | null,
  location: null as Location | null,
};
